// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsConditionsRouteImport } from './routes/terms-conditions'
import { Route as TentangRouteImport } from './routes/tentang'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PuisiIndexRouteImport } from './routes/puisi.index'
import { Route as NovelIndexRouteImport } from './routes/novel.index'
import { Route as KategoriIndexRouteImport } from './routes/kategori.index'
import { Route as CerpenIndexRouteImport } from './routes/cerpen.index'
import { Route as ArtikelIndexRouteImport } from './routes/artikel.index'
import { Route as TagSlugRouteImport } from './routes/tag.$slug'
import { Route as PenulisSlugRouteImport } from './routes/penulis.$slug'
import { Route as NovelSlugRouteImport } from './routes/novel.$slug'
import { Route as KategoriSlugRouteImport } from './routes/kategori.$slug'
import { Route as ArtikelSlugRouteImport } from './routes/artikel.$slug'
import { Route as PuisiIdSlugRouteImport } from './routes/puisi.$id.$slug'
import { Route as NovelIdSlugRouteImport } from './routes/novel.$id.$slug'
import { Route as CerpenIdSlugRouteImport } from './routes/cerpen.$id.$slug'
import { Route as ArtikelIdSlugRouteImport } from './routes/artikel.$id.$slug'
import { Route as NovelIdSlugIndexRouteImport } from './routes/novel.$id.$slug.index'
import { Route as NovelSlugChapterChapterSlugRouteImport } from './routes/novel.$slug.chapter.$chapterSlug'
import { Route as NovelIdSlugChapterChapterIdChapterSlugRouteImport } from './routes/novel.$id.$slug.chapter.$chapterId.$chapterSlug'

const TermsConditionsRoute = TermsConditionsRouteImport.update({
            id: '/terms-conditions',path: '/terms-conditions',getParentRoute: () => rootRouteImport
          })
const TentangRoute = TentangRouteImport.update({
            id: '/tentang',path: '/tentang',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PuisiIndexRoute = PuisiIndexRouteImport.update({
            id: '/puisi/',path: '/puisi/',getParentRoute: () => rootRouteImport
          })
const NovelIndexRoute = NovelIndexRouteImport.update({
            id: '/novel/',path: '/novel/',getParentRoute: () => rootRouteImport
          })
const KategoriIndexRoute = KategoriIndexRouteImport.update({
            id: '/kategori/',path: '/kategori/',getParentRoute: () => rootRouteImport
          })
const CerpenIndexRoute = CerpenIndexRouteImport.update({
            id: '/cerpen/',path: '/cerpen/',getParentRoute: () => rootRouteImport
          })
const ArtikelIndexRoute = ArtikelIndexRouteImport.update({
            id: '/artikel/',path: '/artikel/',getParentRoute: () => rootRouteImport
          })
const TagSlugRoute = TagSlugRouteImport.update({
            id: '/tag/$slug',path: '/tag/$slug',getParentRoute: () => rootRouteImport
          })
const PenulisSlugRoute = PenulisSlugRouteImport.update({
            id: '/penulis/$slug',path: '/penulis/$slug',getParentRoute: () => rootRouteImport
          })
const NovelSlugRoute = NovelSlugRouteImport.update({
            id: '/novel/$slug',path: '/novel/$slug',getParentRoute: () => rootRouteImport
          })
const KategoriSlugRoute = KategoriSlugRouteImport.update({
            id: '/kategori/$slug',path: '/kategori/$slug',getParentRoute: () => rootRouteImport
          })
const ArtikelSlugRoute = ArtikelSlugRouteImport.update({
            id: '/artikel/$slug',path: '/artikel/$slug',getParentRoute: () => rootRouteImport
          })
const PuisiIdSlugRoute = PuisiIdSlugRouteImport.update({
            id: '/puisi/$id/$slug',path: '/puisi/$id/$slug',getParentRoute: () => rootRouteImport
          })
const NovelIdSlugRoute = NovelIdSlugRouteImport.update({
            id: '/novel/$id/$slug',path: '/novel/$id/$slug',getParentRoute: () => rootRouteImport
          })
const CerpenIdSlugRoute = CerpenIdSlugRouteImport.update({
            id: '/cerpen/$id/$slug',path: '/cerpen/$id/$slug',getParentRoute: () => rootRouteImport
          })
const ArtikelIdSlugRoute = ArtikelIdSlugRouteImport.update({
            id: '/artikel/$id/$slug',path: '/artikel/$id/$slug',getParentRoute: () => rootRouteImport
          })
const NovelIdSlugIndexRoute = NovelIdSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NovelIdSlugRoute
          })
const NovelSlugChapterChapterSlugRoute = NovelSlugChapterChapterSlugRouteImport.update({
            id: '/chapter/$chapterSlug',path: '/chapter/$chapterSlug',getParentRoute: () => NovelSlugRoute
          })
const NovelIdSlugChapterChapterIdChapterSlugRoute = NovelIdSlugChapterChapterIdChapterSlugRouteImport.update({
            id: '/chapter/$chapterId/$chapterSlug',path: '/chapter/$chapterId/$chapterSlug',getParentRoute: () => NovelIdSlugRoute
          })





const NovelSlugRouteChildren = {
  NovelSlugChapterChapterSlugRoute: NovelSlugChapterChapterSlugRoute
}

const NovelSlugRouteWithChildren = NovelSlugRoute._addFileChildren(NovelSlugRouteChildren)




const NovelIdSlugRouteChildren = {
  NovelIdSlugIndexRoute: NovelIdSlugIndexRoute,NovelIdSlugChapterChapterIdChapterSlugRoute: NovelIdSlugChapterChapterIdChapterSlugRoute
}

const NovelIdSlugRouteWithChildren = NovelIdSlugRoute._addFileChildren(NovelIdSlugRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,DisclaimerRoute: DisclaimerRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,TentangRoute: TentangRoute,TermsConditionsRoute: TermsConditionsRoute,ArtikelSlugRoute: ArtikelSlugRoute,KategoriSlugRoute: KategoriSlugRoute,NovelSlugRoute: NovelSlugRouteWithChildren,PenulisSlugRoute: PenulisSlugRoute,TagSlugRoute: TagSlugRoute,ArtikelIndexRoute: ArtikelIndexRoute,CerpenIndexRoute: CerpenIndexRoute,KategoriIndexRoute: KategoriIndexRoute,NovelIndexRoute: NovelIndexRoute,PuisiIndexRoute: PuisiIndexRoute,ArtikelIdSlugRoute: ArtikelIdSlugRoute,CerpenIdSlugRoute: CerpenIdSlugRoute,NovelIdSlugRoute: NovelIdSlugRouteWithChildren,PuisiIdSlugRoute: PuisiIdSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)